const Getters = {
  getShopListFromState: (state) => {
    return state.shopList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
